
import { useQuery } from "@tanstack/react-query";
import { fetchPlanData } from "./utils/fetchPlanData";
import { fetchPlanRoutines, fetchRoutinesWithExercises } from "./utils/fetchPlanRoutines";

export const useWorkoutPlan = (planId: string | undefined, options?: { enabled?: boolean }) => {
  const enabled = options?.enabled !== false;
  
  return useQuery({
    queryKey: ["workout-plan", planId],
    queryFn: async () => {
      if (!planId) throw new Error("No plan ID provided");
      
      try {
        const plan = await fetchPlanData(planId);
        console.log("Fetched plan data:", plan);

        // Siempre obtenemos las rutinas vinculadas al plan, sean planes personales o no
        const planRoutines = await fetchPlanRoutines(planId);
        console.log("Fetched plan routines:", planRoutines);

        const routinesWithExercises = await fetchRoutinesWithExercises(planRoutines);
        console.log("Fetched routines with exercises:", routinesWithExercises);

        return {
          ...plan,
          routines: routinesWithExercises
        };
      } catch (error) {
        console.error("Error in useWorkoutPlan:", error);
        throw error;
      }
    },
    enabled: !!planId && enabled,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * Math.pow(2, attemptIndex), 30000),
  });
};
